module.exports = __webpack_public_path__ + "img/logo-lateral.3978fd4f.webp";